import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Nav } from '@deere/fuel-react/Nav';
import {
  ROUTE_AUTH_ERROR,
  ROUTE_FOM,
  ROUTE_FOM_COMPLIANCE_audit,
  ROUTE_FOM_COST,
  ROUTE_FOM_FACTORY_LOAD_SCHEDULE,
  ROUTE_FOM_FORWARDER_ALL_ORDERS,
  ROUTE_FOM_FORWARDER_AVIS,
  ROUTE_FOM_FORWARDER_LOAD_BUILD,
  ROUTE_FOM_FORWARDER_QUOTE_ORDERS,
  ROUTE_FOM_MANAGE_ORDERS,
  ROUTE_FOM_MANAGE_QUOTE_ORDERS,
  ROUTE_FOM_PROVIDER,
  ROUTE_FOM_RESET_ORDERS,
  ROUTE_FOM_COMPLIANCE_AUDIT,
  ROUTE_FOM_ORDER_ADJUSTMENT,
  ROUTE_FOM_REPORTS
} from "../constants/constants";
import { useUserInfo } from "../common/user-context";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import DescriptionIcon from '@mui/icons-material/Description';

const HomeNavBar = () => {
  const { userData } = useUserInfo();
  const location = useLocation();
  const history = useHistory();
  const [isInternal, setIsInternal] = useState(true);
  const [isForwarder, setIsForwarder] = useState(false);
  const [isExternalFactoryuserData, setIsExternalFactoryuserData] =
    useState(false);
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  useEffect(() => {
    setIsInternal(userData.internal);
    setIsForwarder(userData.forwarder);
    setIsExternalFactoryuserData(userData.externalFactoryUser);
  }, [userData]);

  // Handle navigation click
  const handleNavClick = (href) => {
    history.push(href);
  };

  // Build navigation items based on user permissions
  const navItems = [];

  // Home item
  if (isInternal || isForwarder || isExternalFactoryuserData) {
    navItems.push({
      onClick: () => handleNavClick(ROUTE_FOM),
      label: 'Home',
      selected: splitLocation[1] === "",
      startIcon: <HomeOutlinedIcon />
    });
  }

  // Project Setup
  if (isInternal) {
    navItems.push({
      label: 'Project Setup',
      selected: splitLocation[1] === "project-setup",
      startIcon: <AccountTreeOutlinedIcon />,
      subNavigationItems: [
        {
          onClick: () => handleNavClick(ROUTE_FOM_PROVIDER),
          label: 'Provider'
        },
        {
          onClick: () => handleNavClick(ROUTE_FOM_COST),
          label: 'Cost'
        }
      ]
    });
  }

  // Order Management for Internal users
  if (isInternal) {
    navItems.push({
      label: 'Order Management',
      selected: splitLocation[1] === "order-management",
      startIcon: <ListAltOutlinedIcon />,
      subNavigationItems: [
        {
          onClick: () => handleNavClick(ROUTE_FOM_MANAGE_ORDERS),
          label: 'Manage Orders'
        },
        {
          onClick: () => handleNavClick(ROUTE_FOM_RESET_ORDERS),
          label: 'Reset Error Orders'
        },
        {
          onClick: () => handleNavClick(ROUTE_FOM_MANAGE_QUOTE_ORDERS),
          label: 'Manage Quotes'
        },
        {
          onClick: () => handleNavClick(ROUTE_FOM_ORDER_ADJUSTMENT),
          label: 'Control Tower'
        }
      ]
    });
  }

  // Order Management for External Factory users
  if (isExternalFactoryuserData) {
    navItems.push({
      label: 'Order Management',
      selected: splitLocation[1] === "order-management",
      startIcon: <ListAltOutlinedIcon />,
      subNavigationItems: [
        {
          onClick: () => handleNavClick(ROUTE_FOM_ORDER_ADJUSTMENT),
          label: 'Control Tower'
        }
      ]
    });
  }

  // Forwarder
  if (isInternal || isForwarder) {
    navItems.push({
      label: 'Forwarder',
      selected: splitLocation[1] === "forwarder",
      startIcon: <LocalShippingOutlinedIcon />,
      subNavigationItems: [
        {
          onClick: () => handleNavClick(ROUTE_FOM_FORWARDER_LOAD_BUILD),
          label: 'Load Build'
        },
        {
          onClick: () => handleNavClick(ROUTE_FOM_FORWARDER_AVIS),
          label: 'AVIS'
        },
        {
          onClick: () => handleNavClick(ROUTE_FOM_FORWARDER_ALL_ORDERS),
          label: 'All Orders'
        },
        {
          onClick: () => handleNavClick(ROUTE_FOM_FORWARDER_QUOTE_ORDERS),
          label: 'Quoting'
        }
      ]
    });
  }

  // Factory
  if (isInternal || isExternalFactoryuserData) {
    navItems.push({
      label: 'Factory',
      selected: splitLocation[1] === "factory",
      startIcon: <FactoryOutlinedIcon />,
      subNavigationItems: [
        {
          onClick: () => handleNavClick(ROUTE_FOM_FACTORY_LOAD_SCHEDULE),
          label: 'Load Schedule'
        }
      ]
    });
  }

  // Compliance
  if (isInternal) {
    navItems.push({
      label: 'Compliance',
      selected: splitLocation[1] === "compliance",
      startIcon: <AssuredWorkloadIcon />,
      subNavigationItems: [
        {
          onClick: () => handleNavClick(ROUTE_FOM_COMPLIANCE_AUDIT),
          label: 'Audit'
        }
      ]
    });
  }

  // Reports
  if (isInternal) {
    navItems.push({
      label: 'Reports',
      selected: splitLocation[1] === "reports",
      startIcon: <DescriptionIcon />,
      onClick: () => handleNavClick(ROUTE_FOM_REPORTS)
    });
  }

  return (
    <Nav items={navItems} variant="top" />
  );
};

export default HomeNavBar;
